import api from "../../services/api";

export const FETCH_GETCOUNTRIES_FULFILLED = "FETCH_GETCOUNTRIES_FULFILLED";
export const FETCH_GETCOUNTRIES_REJECTED = "FETCH_GETCOUNTRIES_REJECTED";
export const FETCH_GETCOUNTRIES_PENDING = "FETCH_GETCOUNTRIES_PENDING";
export const RESET_GETCOUNTRIES = "RESET_GETCOUNTRIES";


export function getCountries(word) {
  return (dispatch) => {
      dispatch({ type: FETCH_GETCOUNTRIES_PENDING });
      api.get(`/gate/address/lookup/10/${word}`)
          .then(response => {
              dispatch({
                  type: FETCH_GETCOUNTRIES_FULFILLED,
                  payload: response.data,
              });
          })
          .catch(error => {
              dispatch({
                  type: FETCH_GETCOUNTRIES_REJECTED,
                  payload: error,
              });
          });
  };
}

export function resetGetCountries() {
  return (dispatch) => {
      dispatch({
          type: RESET_GETCOUNTRIES,
      });
  };
}
